import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import { CONTENT_ADDED_TO_CART } from '~/constants/segmentActions';
import { segmentTracking } from '~/common/segment/track';
import { doesUserNeedsToPurchaseContent } from '~/components/academies/common/with-academy-theme';
import { WRModals } from '~/components/wr-modals/wr-modals-container';
import { media, theme } from '../../../styles';
import AcademyLearnerStats from '../learner/academy-learner-stats';
import WRButton from '../../widget/wr-button';
import EcommerceUtils from '../../ecommerce/ecommerce-utils';
import { showLoader } from '../../../common';
import academyStyles from './academy-styles';

export default class AcademyThemeBanner extends Component {
  render() {
    const bannerClasses = this.getBannerClasses();
    const bannerContentClasses = this.getBannerContentClasses();
    const foregroundImage =
      typeof this.props.foregroundImage === 'object' ? (
        this.props.foregroundImage
      ) : (
        <AcademyBannerForegroundImage backgroundImage={this.props.foregroundImage} className="foreground-image" />
      );

    const renderedStats = !_.isEmpty(this.props.stats) ? (
      <AcademyLearnerStats color={this.props.titleColor} stats={this.props.stats} textAlign={this.props.textAlign} />
    ) : (
      ''
    );

    return (
      <AcademyBanner
        backgroundColor={this.props.backgroundColor}
        backgroundImage={this.props.backgroundImage || APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY}
        className={bannerClasses.join(' ')}
        darkenBackground={this.props.darkenBackgroundImage}
        descriptionColor={this.props.descriptionColor}
        extraPaddingTop={parseInt(this.props.logoHeight) - APP_CONSTANTS.ACADEMY_THEME_DEFAULT_LOGO_HEIGHT}
        heightStyle={this.props.heightStyle || 'tall'}
        noContent={this.props.noContent}
        style={this.props.style || {}}
        titleColor={this.props.titleColor}
      >
        {!this.props.noContent && (
          <div className="academy-content-banner-wrapper">
            {this.props.foregroundImage && foregroundImage}
            <div className={bannerContentClasses.join(' ')}>
              <h1 className={academyCustomCSS.header.bannerMainHeading}>{this.props.title}</h1>
              {this.props.description && (
                <p className={academyCustomCSS.header.bannerSubHeading}>{this.props.description}</p>
              )}
              {renderedStats}
              {!_.isEmpty(this.props.button) &&
                this.props.button.link &&
                this.props.button.linkText &&
                this.renderButton()}
            </div>
          </div>
        )}
      </AcademyBanner>
    );
  }

  getBannerClasses = () => {
    const bannerClasses = [];
    bannerClasses.push('academy-banner');
    bannerClasses.push(academyCustomCSS.header.navImageBackground);
    if (this.props.foregroundImage) bannerClasses.push('has-foreground-image');
    if (this.props.imageAlign) bannerClasses.push(`image-align-${this.props.imageAlign}`);
    if (this.props.imageStyle) bannerClasses.push(`image-style-${this.props.imageStyle}`);

    return bannerClasses;
  };

  getBannerContentClasses = () => {
    const bannerContentClasses = [];
    bannerContentClasses.push('academy-banner-content');
    if (this.props.textAlign) bannerContentClasses.push(`text-align-${this.props.textAlign}`);

    return bannerContentClasses;
  };

  renderButtonLinkText = () => {
    const { linkText, purchasableContentInfo } = this.props.button;
    const { isSoldOut } = purchasableContentInfo;
    const doesUserNeedsToPurchaseContentAndIsSoldOut =
      doesUserNeedsToPurchaseContent(purchasableContentInfo) && isSoldOut;

    return (
      <RenderButtonLinkTextWrapper>
        <RenderButtonLinkText doesUserNeedsToPurchaseContentAndIsSoldOut={doesUserNeedsToPurchaseContentAndIsSoldOut}>
          {linkText}
        </RenderButtonLinkText>
        {doesUserNeedsToPurchaseContentAndIsSoldOut && <RenderButtonLinkSoldOut>Sold Out</RenderButtonLinkSoldOut>}
      </RenderButtonLinkTextWrapper>
    );
  };

  renderButton = () => (
    <EnrollButtonWrapper>
      <WRButton
        className={academyCustomCSS.header.bannerCta}
        bgColor={this.props.button.backgroundColor ? this.props.button.backgroundColor : null}
        onClick={this.handleAddingPurchasableItemToCart}
        large
      >
        {this.renderButtonLinkText()}
      </WRButton>
    </EnrollButtonWrapper>
  );

  // TODO: this is not great... this function does not belong in the scope of this component...
  handleAddingPurchasableItemToCart = async () => {
    const { button } = this.props;
    const { purchasableContentInfo } = button;
    const { contentId, contentType, isSoldOut } = purchasableContentInfo;

    if (doesUserNeedsToPurchaseContent(purchasableContentInfo)) {
      if (isSoldOut) {
        WRModals.alert('This content is sold out and is not available for purchase at this time.');
      } else {
        showLoader();
        await EcommerceUtils.addToCart(contentId, contentType);
        // TODO: this is adding an item to a cart, not a purchase?
        this.handleSegmentTrackingContentAccessed();
        location.href = button.link;
      }
    } else {
      location.href = button.link;
    }
  };

  handleSegmentTrackingContentAccessed = () => {
    const {
      academyContent,
      academyContent: { content },
    } = this.props;
    const segmentPayload = {
      segmentEventName: CONTENT_ADDED_TO_CART,
      properties: {
        contentType: academyContent.contentType,
        contentId: academyContent.id,
        contentTitle: content.title,
      },
    };
    segmentTracking(segmentPayload);
  };
}

const AcademyBanner = styled.div`
  padding: calc(180px + ${(props) => props.extraPaddingTop}px) 4rem 120px;
  ${(props) =>
    props.noContent &&
    `
    padding-top: calc(0px + ${props.extraPaddingTop}px);
    padding-bottom: 0;
    height: ${academyStyles.header.headerShorterHeight}px;
  `}
  ${(props) => props.heightStyle === 'shorter' && `padding: calc(120px + ${props.extraPaddingTop}px) 4rem 60px;`}
  ${(props) => props.heightStyle === 'short' && `padding: calc(140px + ${props.extraPaddingTop}px) 4rem 80px;`}
  ${media.mobile} {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  ${(props) => props.backgroundImage && `background: url(${props.backgroundImage}) center center no-repeat;`}
  ${(props) =>
    props.backgroundColor &&
    `
    background: none;
    background-color: ${props.backgroundColor};
  `}
  background-size: cover;
  position: relative;
  ${(props) =>
    props.darkenBackground &&
    `
    &:after {
      content: '';
      display: block;
      background: rgba(0, 0, 0, .5);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }
  `}
  h1 {
    font-size: 3rem;
    margin-top: 0;
    margin-bottom: 15px;
    color: ${(props) => props.titleColor};
    ${theme.font.bold}

    @media (max-width: 420px) {
      overflow-wrap: break-word;
    }
  }
  p {
    font-size: 1.125rem;
    line-height: 1.5;
    margin-bottom: 0;
    white-space: pre-wrap;
    color: ${(props) => props.descriptionColor};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .academy-banner-content {
    position: relative;
    z-index: 10;
    &.text-align-left {
      text-align: left;
    }
    &.text-align-center {
      text-align: center;
    }
    &.text-align-right {
      text-align: right;
    }
  }
  .academy-content-banner-wrapper {
    max-width: ${academyStyles.common.maxWidth}px;
    margin: 0 auto;
  }
  &.has-foreground-image {
    .academy-content-banner-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      ${media.mobile} {
        flex-wrap: wrap;
      }
    }
    .academy-banner-content {
      width: 61%;
      order: 2;
      z-index: 10;
      ${media.mobile} {
        width: 100%;
        order: 2 !important;
      }
    }
    &.image-align-right {
      .foreground-image {
        order: 2;
      }
      .academy-banner-content {
        order: 1;
      }
    }
    &.image-style-circle {
      .foreground-image {
        border-radius: 50%;
      }
    }
    &.image-style-diamond {
      .foreground-image {
        clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
      }
    }
  }

  @media print {
    display: none;
  }
`;

const AcademyBannerForegroundImage = styled.div`
  background: url(${(props) => props.backgroundImage}) center center no-repeat transparent;
  background-size: contain;
  width: 35%;
  height: 0;
  padding-bottom: 25%;
  display: block;
  order: 1;
  position: relative;
  z-index: 10;
  ${media.mobile} {
    width: 100%;
    padding-bottom: 70%;
    margin-bottom: 1.5rem;
  }
`;

const EnrollButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;

const RenderButtonLinkTextWrapper = styled.div`
  display: inline-block;
`;

const RenderButtonLinkText = styled.span`
  text-decoration: ${(props) => (props.doesUserNeedsToPurchaseContentAndIsSoldOut ? 'line-through' : '')};
`;

const RenderButtonLinkSoldOut = styled.span`
  padding-left: 10px;
`;
